import { preferNativePlaybackAudio } from '@/lib/audioFx';
import { mediaUrl } from '@/lib/api';

export function detachRadioHls(): void {
  // Native HLS only — nothing to tear down beyond clearing audio.src in callers.
}

/**
 * True when the UA can play our radio m3u8 natively (Safari / iOS).
 * Whole-track MP3 “segments” are fine for Apple’s HLS stack; hls.js is not
 * reliable for that shape — Chrome/Firefox use progressive MP3 instead.
 */
export function radioHlsSupported(audio?: HTMLAudioElement | null): boolean {
  const el =
    audio ||
    (typeof document !== 'undefined' ? document.createElement('audio') : null);
  if (!el?.canPlayType) return false;
  return /maybe|probably/i.test(
    el.canPlayType('application/vnd.apple.mpegurl'),
  );
}

/** Media worker day-loop playlist — OS advances tracks without JS play() after ended. */
export function radioPlaylistUrl(shiftMs = 0, bust = false): string {
  const url = new URL(mediaUrl('/stream/radio.m3u8'));
  const shift = Math.max(0, Math.floor(shiftMs));
  if (shift > 0) url.searchParams.set('shift', String(shift));
  if (bust) url.searchParams.set('_', String(Date.now()));
  return url.href;
}

/** @deprecated Prefer preferNativePlaybackAudio from audioFx. */
export function preferNativeRadioAudio(): boolean {
  return preferNativePlaybackAudio();
}

/**
 * Attach a day-loop radio m3u8 for native HLS only (Safari / iOS).
 */
export function attachRadioHls(
  audio: HTMLAudioElement,
  playlistUrl: string,
): Promise<void> {
  detachRadioHls();

  if (!radioHlsSupported(audio)) {
    return Promise.reject(new Error('Native HLS audio not supported'));
  }

  audio.src = playlistUrl;
  try {
    audio.load();
  } catch {
    /* ignore */
  }
  return Promise.resolve();
}
